var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "onboarding-feature-card",
      class: { selected: _vm.selected },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _vm.feature.network
        ? _c("div", { staticClass: "onboarding-feature-network-badge" }, [
            _c("img", {
              attrs: {
                src: _vm.getNetworkIcon(_vm.feature.network),
                alt: _vm.feature.network,
              },
            }),
          ])
        : _vm._e(),
      _c("div", { staticClass: "onboarding-feature-content" }, [
        _c("h3", { staticClass: "onboarding-feature-title" }, [
          _vm._v("\n      " + _vm._s(_vm.feature.title) + "\n      "),
          _vm.feature.network
            ? _c(
                "svg",
                {
                  staticClass: "native-icon",
                  attrs: {
                    width: "18",
                    height: "18",
                    viewBox: "0 0 64 64",
                    xmlns: "http://www.w3.org/2000/svg",
                    "stroke-width": "3",
                    stroke: "none",
                    fill: "#555e75",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M37.34,7.36a.12.12,0,0,1,.18.13c-.47,1.86-2.78,12.63,5.57,19.62,8.16,6.84,8.41,17.13,2.33,24-7.27,8.23-19.84,6.78-25.25,1.37C16.36,48.69,9.44,36.33,21.29,26a.1.1,0,0,1,.16,0c.29,1.23,2.3,9,7.66,10,.25,0,.37-.11.25-.34C27.78,32.6,20.66,17,37.34,7.36Z",
                      "stroke-linecap": "round",
                    },
                  }),
                ]
              )
            : _vm._e(),
        ]),
        _vm.feature.description
          ? _c("p", {
              staticClass: "onboarding-feature-description",
              domProps: { innerHTML: _vm._s(_vm.feature.description) },
            })
          : _vm._e(),
        _vm.feature.badges && _vm.feature.badges.length > 0
          ? _c(
              "div",
              { staticClass: "onboarding-feature-badges" },
              _vm._l(_vm.feature.badges, function (badge, index) {
                return _c(
                  "span",
                  {
                    key: index,
                    staticClass: "onboarding-feature-badge",
                    attrs: { "data-tooltip": _vm.getBadgeDescription(badge) },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getBadgeLabel(badge)) +
                        "\n      "
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }